import type { IssueFieldQuestionMap } from "services/issues/issuesStore";

export const CH_IDV_URL = "https://www.gov.uk/guidance/verify-your-identity-for-companies-house";

export enum CHVerificationQuestionV2 {
  HasPersonalCode = "HAS_PERSONAL_CODE",
  IdvConsent = "IDV_CONSENT",
  RequestIdConfirmation = "REQUEST_ID_CONFIRMATION",
  IdConfirmationProcessing = "ID_CONFIRMATION_PROCESSING",
  EnterPersonalCode = "ENTER_PERSONAL_CODE",
  MultiDirectorVerification = "MULTI_DIRECTOR_VERIFICATION",
  RejectFlowSubmission = "REJECT_FLOW_SUBMISSION",
}

export const ISSUE_FIELD_TO_QUESTION: IssueFieldQuestionMap<CHVerificationQuestionV2> = {
  ch_code: CHVerificationQuestionV2.HasPersonalCode,
  all_ch_codes: CHVerificationQuestionV2.MultiDirectorVerification,
};

export const ISSUE_REJECTION_SUBMISSION_QUESTION: IssueFieldQuestionMap<CHVerificationQuestionV2> = {
  ch_code: CHVerificationQuestionV2.RejectFlowSubmission,
  all_ch_codes: CHVerificationQuestionV2.RejectFlowSubmission,
};

export const CH_VERIFICATION_FIELD_TO_PATH_V2: Record<CHVerificationQuestionV2, string> = {
  [CHVerificationQuestionV2.HasPersonalCode]: "has-personal-code",
  [CHVerificationQuestionV2.IdvConsent]: "idv-consent",
  [CHVerificationQuestionV2.RequestIdConfirmation]: "request-id-confirmation",
  [CHVerificationQuestionV2.IdConfirmationProcessing]: "id-confirmation-processing",
  [CHVerificationQuestionV2.EnterPersonalCode]: "enter-personal-code",
  [CHVerificationQuestionV2.MultiDirectorVerification]: "multi-director-verification",
  [CHVerificationQuestionV2.RejectFlowSubmission]: "reject-flow-submission",
};
